import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaIdentifierDefinition } from './TypedDefinition'

export const SchemaIdentifierPlugin = createSchemaPlugin(
  'Schema.Identifier',
  SchemaIdentifierDefinition
)
